export enum ReferralStatus {
  PENDING = 'pending',
  INVITED = 'invited',
  BOOKED = 'booked',
  BOOKED_FREE_CONSULT = 'booked_free_consult',
  COMPLETED = 'completed'
}
